import { baseUrl } from "../../../../lib/routes/baseUrl";
import buildUrl from "../../../../lib/utils/buildUrl";
import { IObjectCharTypesSearch } from "../../types/ICharacteristicsSearch";

export const searchObjectCharTypesRoute = (params: IObjectCharTypesSearch<string>) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "object-char-types", "search"].join("/"),
    searchParams: { ...params },
  });
};

export const getCharacteristicDicRoute = (dictType: string) =>
  buildUrl({ url: `${baseUrl}/dict-api/dictionaries/${dictType}` });

export const searchObjectTypesRoute = () => {
  return buildUrl({
    url: [baseUrl, "dict-api", "object-types"].join("/"),
  });
};
